

import { apiProxy } from '../util-lib/http';
import { ensureParams } from '../util-lib/api-proxy';

articlesDetail._definedParams = {
  articleId: ''
};

export async function articlesDetail(params = articlesDetail._definedParams) {
  const api = 'api/v1.0/Poi/Article/ArticleDetail';
  params = ensureParams(params, articlesDetail._definedParams);
  const data = await apiProxy.get(api, { params });
  return data.getArticleDetail.data;
}

getGoodsList._definedParams = {
  articleId: '',
  page: '',
  pageSize: 20
};

export async function getGoodsList(params = getGoodsList._definedParams) {
  const api = 'api/v1.0/Poi/Article/ArticleGoodsList';
  params = ensureParams(params, getGoodsList._definedParams);
  const data = await apiProxy.get(api, { params });
  return data.getArticleGoodsList.data;
}
